import React, { useState, useContext } from "react";
import logo from "../../assets/images/logo.png";
import { VersionContext } from "../../context";
import { useNavigate } from "react-router-dom";
import background from "../../assets/images/background.png";
import title from "../../assets/images/title.png";
import { getPlatform } from "../../utils";
import DownloadComponent from "../../components/DownloadComponent";
import "./index.css";

type ItabItem = {
  tabLabel: string;
  key: string;
  imgArr: Array<number>;
};

const Android = () => {
  const { appVersionData } = useContext(VersionContext);
  const info = appVersionData.androidVersionInfo;
  const [activeTab, setActiveTab] = useState<string>("huawei");
  const [imgArr, setimgArr] = useState<Array<number>>([1, 2, 3]);
  const platform = getPlatform();
  const navigate = useNavigate();

  if (platform === "iOS") {
    navigate("/");
  }

  const tabArr: Array<ItabItem> = [
    {
      tabLabel: "华为",
      key: "huawei",
      imgArr: [1, 2, 3],
    },
    {
      tabLabel: "小米",
      key: "xiaomi",
      imgArr: [1, 2, 3, 4],
    },
    {
      tabLabel: "oppo",
      key: "oppo",
      imgArr: [1, 2, 3],
    },
    {
      tabLabel: "vivo",
      key: "vivo",
      imgArr: [1, 2, 3],
    },
    {
      tabLabel: "荣耀",
      key: "honor",
      imgArr: [1, 2, 3],
    },
  ];

  const changeTab = (item: any) => {
    setimgArr(item.imgArr);
    setActiveTab(item.key);
  };

  return (
    <div className="android">
      {/*<img className="backgroundIcon" src={background} alt="background" />*/}
      <div className="tabs">
        {(tabArr || []).map((item, index) => {
          const active = activeTab === item.key;
          return (
            <div key={`androidTab-${index}`}>
              <div
                className="tab"
                onClick={() => {
                  changeTab(item);
                }}
              >
                <p className={active ? "tabLabel tabLabelactive" : "tabLabel"}>
                  {item.tabLabel}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="androidPage">
        <div className="androidPageheader">
          <p>
            <img alt="logo" className="logo" src={logo} />
          </p>
          <img className="title" src={title} alt="background" />
          {info && (
            <DownloadComponent
              downloadUrl={info?.packageUrl || ""}
              fileName={info?.packageName || ""}
            />
          )}
        </div>
        <div className="androidPageContainer">
          {imgArr.map((i, index) => {
            return (
              <div
                key={`android-${index}`}
                className="androidPageContainerWrap"
              >
                <img
                  className="androidPageContainerImg"
                  src={require(`../../assets/images/${activeTab}/${activeTab}${i}.png`)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Android;
